import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ebfc4fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "source-mapping columns" }
const _hoisted_2 = { class: "column is-6" }
const _hoisted_3 = { class: "source panel" }
const _hoisted_4 = { class: "panel-heading is-flex is-align-items-center is-justify-content-space-between is-flex-wrap-wrap" }
const _hoisted_5 = { class: "has-text-weight-bold" }
const _hoisted_6 = { class: "is-flex gap-1" }
const _hoisted_7 = { class: "button is-text is-small" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "An error occurred while parsing the CSV file:", -1))
const _hoisted_9 = {
  key: 0,
  class: "content"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "To fix the issue, you can:", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = ["onMouseenter", "onMouseleave"]
const _hoisted_15 = {
  key: 0,
  class: "has-text-grey"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column is-1" }, null, -1))
const _hoisted_17 = { class: "column is-5" }
const _hoisted_18 = {
  key: 0,
  class: "content"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You haven't mapped any tables yet.", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "The first step is to define which columns of your CSV will be dimensions of your cube:", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Select columns that will be dimensions of your cube on the CSV file (left column)"),
  /*#__PURE__*/_createElementVNode("li", null, "Click \"Create table from selected columns\""),
  /*#__PURE__*/_createElementVNode("li", null, "Select the type \"Cube table\" in the form. The Cube table represents the structure of your cube."),
  /*#__PURE__*/_createElementVNode("li", null, "After submitting the form, you should already be able to see a first version of your cube in the \"Cube Preview\" (bottom of the screen).")
], -1))
const _hoisted_22 = [
  _hoisted_19,
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " No tables mapped from this CSV file yet ", -1))
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_button = _resolveComponent("o-button")!
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_o_dropdown_item = _resolveComponent("o-dropdown-item")!
  const _component_o_dropdown = _resolveComponent("o-dropdown")!
  const _component_b_message = _resolveComponent("b-message")!
  const _component_o_checkbox = _resolveComponent("o-checkbox")!
  const _component_o_tooltip = _resolveComponent("o-tooltip")!
  const _component_mapper_table = _resolveComponent("mapper-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.source.name), 1),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.tableCollection.actions.create)
              ? (_openBlock(), _createBlock(_component_o_button, {
                  key: 0,
                  disabled: _ctx.selectedColumns.length === 0,
                  tag: "router-link",
                  to: { name: 'TableCreate', query: _ctx.createTableQueryParams },
                  size: "small",
                  "icon-left": "plus"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Create table from selected columns ")
                  ]),
                  _: 1
                }, 8, ["disabled", "to"]))
              : _createCommentVNode("", true),
            _createVNode(_component_o_dropdown, {
              position: "bottom-left",
              class: "has-text-weight-normal",
              "aria-role": "list"
            }, {
              trigger: _withCtx(() => [
                _createElementVNode("button", _hoisted_7, [
                  _createVNode(_component_o_icon, { icon: "ellipsis-h" })
                ])
              ]),
              default: _withCtx(() => [
                (_ctx.source.actions.edit)
                  ? (_openBlock(), _createBlock(_component_o_dropdown_item, {
                      key: 0,
                      tag: "div",
                      "item-class": "p",
                      clickable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          class: "dropdown-item",
                          to: { name: 'SourceEdit', params: { sourceId: _ctx.source.clientPath } }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_o_icon, { icon: "pencil-alt" }),
                            _createTextVNode(" " + _toDisplayString(_ctx.source.actions.edit.title), 1)
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.source.actions.replace)
                  ? (_openBlock(), _createBlock(_component_o_dropdown_item, {
                      key: 1,
                      tag: "div",
                      "item-class": "p"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          class: "dropdown-item",
                          to: { name: 'SourceReplaceCSV', params: { sourceId: _ctx.source.clientPath } }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_o_icon, { icon: "upload" }),
                            _createTextVNode(" " + _toDisplayString(_ctx.source.actions.replace.title), 1)
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.source.actions.download)
                  ? (_openBlock(), _createBlock(_component_o_dropdown_item, {
                      key: 2,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadSource(_ctx.source)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_o_icon, { icon: "download" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.source.actions.download.title), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.source.actions.delete)
                  ? (_openBlock(), _createBlock(_component_o_dropdown_item, {
                      key: 3,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteSource(_ctx.source)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_o_icon, { icon: "trash" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.source.actions.delete.title), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        (_ctx.source.errorMessages.length)
          ? (_openBlock(), _createBlock(_component_b_message, {
              key: 0,
              type: "is-danger",
              class: "content mb-0"
            }, {
              default: _withCtx(() => [
                _hoisted_8,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.source.errorMessages, (error) => {
                  return (_openBlock(), _createElementBlock("pre", { key: error }, _toDisplayString(error), 1))
                }), 128)),
                (_ctx.source.actions.delete || _ctx.source.actions.edit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("ul", null, [
                        (_ctx.source.actions.edit)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                              _createVNode(_component_router_link, {
                                to: { name: 'SourceEdit', params: { sourceId: _ctx.source.clientPath } }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Adjust the CSV settings ")
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.source.actions.replace)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                              _createVNode(_component_router_link, {
                                to: { name: 'SourceReplaceCSV', params: { sourceId: _ctx.source.clientPath } }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Replace this file with a valid one ")
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.source.actions.delete)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                              _createElementVNode("a", {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteSource(_ctx.source)))
                              }, "Delete this file"),
                              _createTextVNode(", fix it and upload it again ")
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.source.columns, (column) => {
          return (_openBlock(), _createElementBlock("div", {
            key: column.id.value,
            class: "panel-block is-flex is-justify-content-space-between",
            onMouseenter: ($event: any) => (_ctx.highlightArrows(column)),
            onMouseleave: ($event: any) => (_ctx.unhighlightArrows(column))
          }, [
            _createVNode(_component_o_checkbox, {
              "model-value": _ctx.selectedColumnsMap[column.clientPath],
              "onUpdate:modelValue": ($event: any) => (_ctx.selectedColumnsMap[column.clientPath] = $event),
              class: "source-column-name"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(column.name) + " ", 1),
                (column.samples.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, "  (" + _toDisplayString(column.samples.slice(0, 3).join(", ")) + ") ", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["model-value", "onUpdate:modelValue"]),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getColumnMappings(column), ({table, columnMapping}) => {
                return (_openBlock(), _createBlock(_component_o_tooltip, {
                  key: columnMapping.id.value,
                  class: "source-column-mapping",
                  style: _normalizeStyle({ 'background-color': table.color }),
                  label: table.name + ' / ' + columnMapping.targetProperty.value,
                  "data-arrow-target": columnMapping.id.value
                }, null, 8, ["style", "label", "data-arrow-target"]))
              }), 128))
            ])
          ], 40, _hoisted_14))
        }), 128))
      ])
    ]),
    _hoisted_16,
    _createElementVNode("div", _hoisted_17, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sourceTables, (table) => {
        return (_openBlock(), _createBlock(_component_mapper_table, {
          key: table.id.value,
          table: table,
          onHighlightArrows: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('highlight-arrows', $event))),
          onUnhighlightArrows: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('unhighlight-arrows', $event)))
        }, null, 8, ["table"]))
      }), 128)),
      (_ctx.isFirstSource && _ctx.tables.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_22))
        : (_ctx.sourceTables.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
          : _createCommentVNode("", true)
    ])
  ]))
}